/*
=========================================================
* Material Kit 2 PRO React - v2.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 PRO React components
import TransparentBlogCard from "examples/Cards/BlogCards/TransparentBlogCard";
import BackgroundBlogCard from "examples/Cards/BlogCards/BackgroundBlogCard";

// Images
import solucoes1 from "assets/images/produtos.jpg";
import solucoes2 from "assets/images/treinamento.jpg";
import solucoes3 from "assets/images/servicos.jpg";
import solucoes4 from "assets/images/pen-test.png";      // SOC / Incidentes Críticos
import solucoes5 from "assets/images/estrutura.jpg";     // Soluções por Setor

function Solucoes() {
  return (
    <MKBox component="section" py={2}>
      <Container>
        <Grid container item xs={12} lg={6}>
          <MKTypography variant="h3" mb={6}>
            O Que Oferecemos
          </MKTypography>
        </Grid>
        <Grid container spacing={3}>

          <Grid item xs={12} sm={6} lg={3}>
            <TransparentBlogCard
              image={solucoes1}
              title="Produtos"
              description="Hardware e software sob medida para a sua necessidade."
              action={{
                type: "internal",
                route: "/pages/produtos",
                color: "info",
                label: "saiba mais",
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} lg={3}>
            <TransparentBlogCard
              image={solucoes2}
              title="Academia Cibernética"
              description="Formação profissional, com certificação internacional, e reconhecimento de mercado."
              action={{
                type: "internal",
                route: "/pages/academia-ciber",
                color: "info",
                label: "saiba mais",
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} lg={3}>
            <TransparentBlogCard
              image={solucoes3}
              title="Serviços"
              description="Consultoria, auditoria, pen testing e suporte contínuo para a sua segurança cibernética."
              action={{
                type: "internal",
                route: "/pages/servicos",
                color: "info",
                label: "saiba mais",
              }}
            />
          </Grid>

          {/* NOVO: SOC / Incidentes Críticos */}
          <Grid item xs={12} sm={6} lg={3}>
            <TransparentBlogCard
              image={solucoes4}
              title="SOC & Resposta a Incidentes"
              description="Detecção, correlação e resposta automatizada a ameaças, com conformidade LGPD e retenção forense."
              action={{
                type: "internal",
                route: "/pages/servicos/soc",  // TODO: atualizar para /pages/servicos/soc quando a página for criada
                color: "info",
                label: "saiba mais",
              }}
            />
          </Grid>

          {/* NOVO: Soluções por Setor — linha separada, card mais largo */}
          <Grid item xs={12} sm={12} lg={12}>
            <BackgroundBlogCard
              image={solucoes5}
              title="Soluções por Setor"
              description="Aviação, turismo, saúde e setor público — soluções integradas de hardware, segurança e treinamento desenhadas para os desafios do seu setor."
              action={{
                type: "internal",
                route: "/pages/ajuda/contate-nos",
                label: "fale com um especialista",
              }}
            />
          </Grid>

        </Grid>
      </Container>
    </MKBox>
  );
}

export default Solucoes;
